(() => {
  const nav = document.querySelector('.sp-mobile-nav');
  if (!nav) return;
  const close = () => {
    nav.removeAttribute('open');
    document.documentElement.classList.remove('sp-menu-open');
  };
  nav.addEventListener('toggle', () => {
    document.documentElement.classList.toggle('sp-menu-open', nav.open);
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && nav.open) {
      close();
      nav.querySelector(':scope > summary')?.focus();
    }
  });
  document.addEventListener('click', (event) => {
    if (nav.open && !nav.contains(event.target)) close();
  });
  nav.querySelectorAll('a').forEach((link) => link.addEventListener('click', close));
})();
